module.exports = __webpack_public_path__ + "img/Rectangle 22.a6685ea8.png";